export default function DisabledTextArea({ value, id, name }) {
  function getNumberOfLines(text) {
    if (text) {
      let match = text.match(/[^\r\n]+/g);
      return match ? match.length + 3 : 3;
    }
  }

  return (
    <textarea id={id} rows={`${getNumberOfLines(value)}`} name={name} disabled>
      {value}
    </textarea>
  );
}
